// Client-side DOMPurify wrapper to prevent hydration issues
let DOMPurify: any = null;

if (typeof window !== 'undefined') {
  // Dynamic import isomorphic-dompurify only on client side
  import('isomorphic-dompurify').then((module) => {
    DOMPurify = module.default;
  });
}

/**
 * Sanitizes HTML content allowing only safe tags
 * Only works on client side to prevent hydration issues
 * @param html - HTML string to sanitize
 * @returns Sanitized HTML string
 */
export function sanitizeHtml(html: string): string {
  // Return unsanitized HTML on server side (should be pre-sanitized)
  if (typeof window === 'undefined' || !DOMPurify) {
    return html;
  }

  // Configure DOMPurify to allow only specific tags
  const config = {
    ALLOWED_TAGS: ['strong', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    FORBID_SCRIPTS: true,
    FORBID_TAGS: ['script', 'object', 'embed', 'link', 'style', 'img'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick']
  };

  return DOMPurify.sanitize(html, config);
}